<template>
  <b-modal ref="user-card-modal" @ok="userCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.users.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="userName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

       <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.loginPage.passwordLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="password"
          type="password"
          :state="isPasswordValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.loginPage.confirmPasswordLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="confirmPassword"
          type="password"
          :state="isConfirmPasswordValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.firstName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="firstName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.lastName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="lastName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.patronymic"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="patronymic"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.role"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="role"
          :options="roleOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.isActive"
        label-for="input-horizontal"
      >
       <b-form-checkbox
          v-model="isActive"
        >
        </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.isActiveToUntillTime"
        label-for="input-horizontal"
      >

        <b-form-datepicker
          v-model="isActiveToUntillTime"
          :state="isActiveToUntillTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="4"
        content-cols-sm
        content-cols-lg="4"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="user.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
    <div v-if="!isFormValid" class="text-danger mt-2" style="font-size: 13px">
      {{ validationErrorMessage }}
    </div>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateUserPage",
  props: {
    user: Object,
    users: Array,
  },
  components: {},
  data() {
    return {
      isFormValid: true,
      validationErrorMessage: null,
      userName: null,
      password: null,
      confirmPassword: null,
      lastName: null,
      firstName: null,
      patronymic: null,
      role: null,
      isActive: null,
      isActiveToUntillTime: null,
      created: null,
      updated: null,
     
      isUserNameValid: null,
      isPasswordValid: null,
      isConfirmPasswordValid: null,
      isLastNameValid: null,
      isFirstNameValid: null,
      isPatronymicValid: null,
      isActiveToUntillTimeValid: null
    };
  },
  computed: {
    roleOptions() {
      const roleOptions = [];
      roleOptions.push("Admin");
      roleOptions.push("Operator");

      return roleOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    open() {
      this.validationErrorMessage = null;
      this.isUserNameValid = null;
      this.isPasswordValid = null;
      this.isConfirmPasswordValid = null;
      this.isLastNameValid = null;
      this.isFirstNameValid = null;
      this.isPatronymicValid = null;
      this.isActiveToUntillTimeValid = null;
      this.password = null;
      this.confirmPassword = null;

      this.userName = this.user.userName;
      this.lastName = this.user.lastName;
      this.firstName = this.user.firstName;
      this.patronymic = this.user.patronymic;
      this.role = this.user.role;
      this.isActive = this.user.isActive;
      this.created = utilsService.formatDateTime(new Date(this.user.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.user.updated * 1000), utilsService.DATE_TIME_FORMAT);
      
      if (!this.user.isActiveToUntillTime || this.user.isActiveToUntillTime == 0 || this.user.isActiveToUntillTime == 1) {
        this.isActiveToUntillTime = utilsService.convertUnixTimeToDate(Math.floor(new Date(9999, 0, 1) / 1000));
      } else {
        this.isActiveToUntillTime = utilsService.convertUnixTimeToDate(this.user.isActiveToUntillTime);
      }

      this.$refs["user-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.userName) {
        this.isUserNameValid = false;
        isValid = false;
      } else {
        this.isUserNameValid = null;
      }

      if (this.password || this.confirmPassword) {
        if (this.password == this.confirmPassword) {
          if (utilsService.isPasswordNotValid(this.password)) {
            this.isPasswordValid = false;
            this.isConfirmPasswordValid = false;
            this.validationErrorMessage = this.$store.state.localization.data.mainPage.azk.users.passwordNotHard;
            isValid = false;
          } else {
            this.isPasswordValid = null;
            this.isConfirmPasswordValid = null;
          }
        } else {
          this.isPasswordValid = false;
          this.isConfirmPasswordValid = false;
          this.validationErrorMessage = this.$store.state.localization.data.mainPage.azk.users.passwordMismatched;
          isValid = false;
        }
      }

      if (!this.lastName) {
        this.isLastNameValid = false;
        isValid = false;
      } else {
        this.isLastNameValid = null;
      }

      if (!this.firstName) {
        this.isFirstNameValid = false;
        isValid = false;
      } else {
        this.isFirstNameValid = null;
      }

      if (!this.patronymic) {
        this.isPatronymicValid = false;
        isValid = false;
      } else {
        this.isPatronymicValid = null;
      }

      if (!this.isActiveToUntillTime) {
        this.isActiveToUntillTimeValid = false;
        isValid = false;
      } else {
        this.isActiveToUntillTimeValid = null;
      }

      this.isFormValid = isValid;
      return isValid;
    },
    async userCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.user.userName = this.userName;
      this.user.lastName = this.lastName;
      this.user.firstName = this.firstName;
      this.user.patronymic = this.patronymic;
      this.user.role = this.role;
      this.user.isActive = this.isActive;
      this.user.isActiveToUntillTime = this.isActiveToUntillTime.getTime() / 1000;

      const updateUserResponse = await azkService.updateUser(this.user);

      if (
        updateUserResponse.isSuccess &&
        updateUserResponse.data &&
        updateUserResponse.data.countInsertedRows == 1
      ) {
        this.$emit("userUpdatedSuccessEvent", this.user);
      } else {
        this.$emit("userUpdatedFailEvent");
      }
    },
  },
};
</script>
